export const socialsList = [
	{
		title: 'Вконтакте',
		url: 'https://vk.com/cultrf',
		icon: 'vk'
	},
	{
		title: 'Одноклассники',
		url: 'https://ok.ru/cultrf',
		icon: 'ok'
	},
	{
		title: 'Telegram',
		url: 'https://t.me/namnezadavali',
		icon: 'telegram'
	},
	{
		title: 'Яндекс.Мессенджер',
		url: 'https://yandex.ru/chat/#/join/0b5f4f63-749c-46e6-a2b9-f14f6a8c435d',
		icon: 'yaMessenger'
	},
	{
		title: 'Подкасты',
		url: '/s/podcasts',
		icon: 'podcast'
	},
	{
		title: 'Яндекс.Дзен',
		url: 'https://zen.yandex.ru/portalculture',
		icon: 'yaDzen'
	},
	{
		title: 'Youtube',
		url: 'https://www.youtube.com/channel/UCUsMExk3L03HXLLv7oIUh-Q',
		icon: 'youtube'
	}
];
